import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77de2f33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagecounter" }
const _hoisted_2 = {
  class: "pdf-title",
  "data-cy": "pdf-overviewpage-mainheader"
}
const _hoisted_3 = {
  class: "pdf-subtitle",
  "data-cy": "pdf-overviewpage-overviewheader"
}
const _hoisted_4 = {
  class: "pdf-subtitle",
  "data-cy": "pdf-overviewpage-overviewheader"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "flex text-sm font-medium border-bottom" }
const _hoisted_7 = { class: "overviewTable flex-1" }
const _hoisted_8 = { "data-cy": "pdf-overviewpage-overviewheader" }
const _hoisted_9 = { "data-cy": "generalData-kesselhersteller" }
const _hoisted_10 = { "data-cy": "generalData-nennwaermeleistung" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  "data-cy": "generalData-weiteresHeizungssystem"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "flex text-sm font-medium border" }
const _hoisted_15 = { class: "resultTable flex-1" }
const _hoisted_16 = { "data-cy": "pdf-overviewpage-overviewheader" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" Die eingestellen "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "technischen Parameter"),
  /*#__PURE__*/_createTextVNode(" sind: ")
], -1))
const _hoisted_18 = { "data-cy": "generalData-kesselhersteller" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" Die "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Heizungspumpe(n)"),
  /*#__PURE__*/_createTextVNode(" arbeiten: ")
], -1))
const _hoisted_20 = { "data-cy": "generalData-nennwaermeleistung" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" Die "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Rohrleitungen"),
  /*#__PURE__*/_createTextVNode(" sind: ")
], -1))
const _hoisted_22 = { "data-cy": "generalData-weiteresHeizungssystem" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" Die "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Armaturen"),
  /*#__PURE__*/_createTextVNode(" sind: ")
], -1))
const _hoisted_24 = { "data-cy": "generalData-weiteresHeizungssystem" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" Unterlagen eines "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "hydraulischen Abgleichs"),
  /*#__PURE__*/_createTextVNode(" sind: ")
], -1))
const _hoisted_26 = { "data-cy": "generalData-weiteresHeizungssystem" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Strangregulierventile"),
  /*#__PURE__*/_createTextVNode(" sind: ")
], -1))
const _hoisted_28 = { "data-cy": "generalData-weiteresHeizungssystem" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { "data-cy": "pdf-overviewpage-overviewheader" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_acon_logo = _resolveComponent("pdf-acon-logo")!
  const _component_PageCounter = _resolveComponent("PageCounter")!
  const _component_pdf_general_data = _resolveComponent("pdf-general-data")!
  const _component_pdf_image_row = _resolveComponent("pdf-image-row")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "data-cy": "pdf-overview-page",
    "pdf-key": _ctx.lang
  }, {
    default: _withCtx(() => [
      _createVNode(_component_pdf_acon_logo),
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_PageCounter)
      ]),
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("hzba.pdf.ergebnisPruefung", 1, { locale: _ctx.lang })), 1),
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.t("hzba.pdf.ensimimavParagraph", 1, { locale: _ctx.lang })), 1),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.t("hzba.pdf.ensimimavSubtitle", 1, { locale: _ctx.lang })), 1),
      _hoisted_5,
      _createVNode(_component_pdf_general_data, {
        hzba: _ctx.ba,
        immobilie: _ctx.immobilie,
        lang: _ctx.lang
      }, null, 8, ["hzba", "immobilie", "lang"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("tr", null, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.t("hzba.pdf.heizung", 1, { locale: _ctx.lang })), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.t("hzba.pdf.kesselhersteller", 1, { locale: _ctx.lang })) + ":", 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.allgemein-tab.liegenschaftDaten.hersteller"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.t("hzba.pdf.nennwaermeleistung", 1, { locale: _ctx.lang })) + ":", 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.allgemein-tab.liegenschaftDaten.nennleistung"
              )?.getCurrentInput() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            (_ctx.useIdentifierFrageFinder(_ctx.ba,'ensimimav.waermeerzeugung-tab.primary.weitereenergiesysteme')?.getCurrentInput())
              ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_ctx.t("hzba.pdf.ensimimav.weitereHeizungssysteme", 1, { locale: _ctx.lang })) + ": ", 1))
              : _createCommentVNode("", true),
            (_ctx.useIdentifierFrageFinder(_ctx.ba,'ensimimav.waermeerzeugung-tab.primary.weitereenergiesysteme')?.getCurrentInput())
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,"ensimimav.waermeerzeugung-tab.primary.bezeichungweitereenergiesysteme")?.getCurrentInput() || ""), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_pdf_image_row, {
        "image-objects": _ctx.ensimimavHeizraumBilder,
        "max-images": 3
      }, null, 8, ["image-objects"]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("tr", null, [
            _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.t("hzba.pdf.ensimimav.ergebnis", 1, { locale: _ctx.lang })), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.anlagenzustand-tab.anlagenzustand-group.technischeParameter"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.anlagenzustand-tab.anlagenzustand-group.heizunspumpen"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_21,
            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.anlagenzustand-tab.anlagenzustand-group.rohrleitungen"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_23,
            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.anlagenzustand-tab.anlagenzustand-group.armaturen"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_25,
            _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.anlagenzustand-tab.anlagenzustand-group.hidraulischerabgleich"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_27,
            _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "ensimimav.anlagenzustand-tab.anlagenzustand-group.strangregulierventile"
              )?.getSelectedAuswahlLabelsString() || "-"), 1),
            _hoisted_29
          ])
        ])
      ]),
      _hoisted_30,
      _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.t("hzba.pdf.heizanlagenbewertung", 1, { locale: _ctx.lang })), 1),
      _hoisted_32,
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", {
          class: _normalizeClass(["box greenbox", _ctx.greenboxhasarrow])
        }, "Optimaler Betrieb", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["box yellowbox", _ctx.yellowboxhasarrow])
        }, "Handlungsbedarf", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["box redbox", _ctx.redboxhasarrow])
        }, "Erhöhter Handlungsbedarf", 2)
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}